import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ResultTreeService {

  constructor(private http: HttpClient) { }

  get(projectId: number, simulationId: any) {
    return this.http.get<any>(
      `/api/project/${projectId}/simulation/${simulationId}/tree`
    );
  }
}
